// Total Operations brand mark. Inline SVG, exact geometry (104:72).
// First ring is always orange; the second ring uses currentColor so it
// renders white on dark surfaces and #0B1526 on light ones. Set size via
// className height (e.g. "h-8 w-auto") to preserve the aspect ratio.
export function TotalOpsMark({ className = "", title = "Total Operations", ...props }) {
  return (
    <svg viewBox="0 0 104 72" fill="none" className={className} xmlns="http://www.w3.org/2000/svg" role="img" aria-label={title} {...props}>
      <circle cx="40" cy="36" r="27" stroke="#E0873E" strokeWidth="7" />
      <circle cx="64" cy="36" r="27" stroke="currentColor" strokeWidth="7" />
    </svg>
  );
}
